"use strict";
'use es6'; // Feature is loosely defined by something we would market on a pricing page
// These values are used for translation keys as well

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  AD_RETARGETING: 'adRetargeting',
  LIVE_CHAT: 'liveChat',
  CONVERSATIONAL_BOTS: 'conversationalBots',
  TEAM_EMAIL: 'teamEmail',
  CONVERSATIONS_INBOX: 'conversationsInbox',
  FORMS: 'forms',
  COLLECTED_FORMS: 'collectedForms',
  AD_MANAGEMENT: 'adManagement',
  GOOGLE_SEARCH_CONSOLE_INTEGRATION: 'googleSearchConsoleIntegration',
  REPORTING_DASHBOARDS: 'reportingDashboards',
  TEAMS: 'teams',
  MOBILE_OPTIMIZATION: 'mobileOptimization',
  PHONE_SUPPORT: 'phoneSupport',
  CALL_TRANSCRIPTION: 'callTranscription',
  STANDARD_CONTACT_SCORING: 'standardContactScoring',
  ALL_CRM_FEATURES: 'allCrmFeatures',
  CALLING_SDK: 'callingSdk',
  STRIPE_INTEGRATION: 'stripeIntegration',
  EMAIL_MARKETING: 'emailMarketing',
  LIST_SEGMENTATION: 'listSegmentation',
  CONTENT_CREATION_TOOLS: 'contentCreationTools',
  SEO_CONTENT_STRATEGY: 'seoContentStrategy',
  SOCIAL_MEDIA: 'socialMedia',
  CALLS_TO_ACTION: 'callsToAction',
  LANDING_PAGES: 'landingPages',
  SSL_CERTIFICATE: 'sslCertificate',
  SUBDOMAIN_AVAILABILITY: 'subdomainAvailability',
  MARKETING_AUTOMATION: 'marketingAutomation',
  SALESFORCE_INTEGRATION: 'salesforceIntegration',
  SMART_CONTENT: 'smartContent',
  WEBSITE_TRAFFIC_ANALYTICS: 'websiteTrafficAnalytics',
  CAMPAIGN_REPORTING: 'campaignReporting',
  ATTRIBUTION_REPORTING: 'attributionReporting',
  AB_TESTING: 'abTesting',
  CUSTOM_REPORTS: 'customReports',
  PREDICTIVE_LEAD_SCORING: 'predictiveLeadScoring',
  CUSTOM_EVENT_TRIGGERS_AND_REPORTING: 'customEventTriggersAndReporting',
  EVENT_BASED_SEGMENTATION: 'eventBasedSegmentation',
  SINGLE_SIGN_ON: 'singleSignOn',
  PARTITIONING: 'partitioning',
  FACEBOOK_MESSENGER: 'facebookMessenger',
  YOUTUBE_INTEGRATION: 'youtubeIntegration',
  FILTERED_ANALYTICS_VIEW: 'filteredAnalyticsView',
  EVENTS_API: 'eventsApi',
  SOCIAL_PERMISSIONS: 'socialPermissions',
  EMAIL_SEND_FREQUENCY_CAP: 'emailSendFrequencyCap',
  EMAIL_TRACKING_NOTIFICATIONS: 'emailTrackingNotifications',
  EMAIL_SCHEDULING: 'emailScheduling',
  SNIPPETS: 'snippets',
  CALLING: 'calling',
  SEQUENCES: 'sequences',
  MEETINGS: 'meetings',
  REP_PRODUCTIVITY_PERFORMANCE: 'repProductivityPerformance',
  REP_PRODUCTIVITY_REPORTS: 'repProductivityReports',
  EMAIL_SUPPORT: 'emailSupport',
  DEAL_PIPELINE: 'dealPipeline',
  PRODUCTS: 'products',
  SIMPLE_AUTOMATION: 'simpleAutomation',
  DEAL_STAGE_TASK_LEAD_ROTATION_AUTOMATION: 'dealStageTaskLeadRotationAutomation',
  REQUIRED_FIELDS: 'requiredFields',
  QUOTES: 'quotes',
  SMART_SEND_TIMES: 'smartSendTimes',
  SEQUENCE_QUEUES: 'sequenceQueues',
  USER_ROLES: 'userRoles',
  MULTI_CURRENCY: 'multiCurrency',
  VIDEO_CREATION: 'videoCreation',
  VIDEO_CREATION_AND_HOSTING: 'videoCreationAndHosting',
  RECURRING_REVENUE_TRACKING: 'recurringRevenueTracking',
  GOALS: 'goals',
  ESIGN: 'eSign',
  QUOTE_BASED_WORKFLOWS: 'quoteBasedWorkflows',
  WORKFLOWS_EXTENSIONS: 'workflowsExtensions',
  CUSTOM_BOTS: 'customBots',
  SLACK: 'slack',
  VIDEO_HOSTING_MANAGEMENT: 'videoHostingManagement',
  PLAYBOOKS: 'playbooks',
  TICKETING: 'ticketing',
  CUSTOMER_FEEDBACK: 'customerFeedback',
  CUSTOMER_SERVICE_AUTOMATION: 'customerServiceAutomation',
  TEMPLATES: 'templates',
  DOCUMENTS: 'documents',
  CONVERSATION_ROUTING: 'conversationRouting',
  KNOWLEDGE_BASE: 'knowledgeBase',
  HIERARCHICAL_TEAMS: 'hierarchicalTeams',
  CALCULATED_PROPERTIES: 'calculatedProperties',
  WEBHOOKS: 'webhooks',
  TIME_TO_CLOSE_REPORTS: 'timeToCloseReports',
  TICKET_STATUS: 'ticketStatus',
  TICKET_ROUTING: 'ticketRouting',
  TICKETS_CLOSED_REPORTS: 'ticketsClosedReports',
  TASK_AUTOMATION: 'taskAutomation',
  TICKET_STATUS_ROUTING_TASK_AUTOMATION: 'ticketStatusRoutingTaskAutomation',
  MULTIPLE_TICKET_PIPELINES: 'multipleTicketPipelines',
  NPS_SURVEYS: 'npsSurveys',
  CUSTOMER_EXPERIENCE_SURVEYS: 'customerExperienceSurveys',
  CUSTOMER_SUPPORT_SURVEYS: 'customerSupportSurveys',
  INSIGHTS_DASHBOARD: 'insightsDashboard',
  HUB_DB_DYNAMIC_CONTENT: 'hubDbDynamicContent',
  WEBSITE_PAGES: 'websitePages',
  DESIGN_MANAGER: 'designManager',
  STAGING_ENVIRONMENT: 'stagingEnvironment',
  TEMPLATE_AND_MODULE_MARKETPLACE: 'templateAndModuleMarketplace',
  WEBSITE_ANALYTICS: 'websiteAnalytics',
  CUSTOM_DOMAINS: 'customDomains',
  UPTIME: 'uptime',
  CONTENT_DELIVERY_NETWORK: 'contentDeliveryNetwork',
  SECURITY_MONITORING_THREAT_DETECTION: 'securityMonitoringThreatDetection',
  CONTACT_MANAGEMENT: 'contactManagement',
  CONTACT_WEBSITE_ACTIVITY: 'contactWebsiteActivity',
  COMPANIES: 'companies',
  DEALS: 'deals',
  TASKS_AND_ACTIVITIES: 'tasksAndActivities',
  COMPANY_INSIGHTS: 'companyInsights',
  GMAIL_AND_OUTLOOK_INTEGRATION: 'gmailAndOutlookIntegration',
  HUBSPOT_CONNECT_INTEGRATIONS: 'hubspotConnectIntegrations',
  CUSTOM_SUPPORT_FORM_FIELDS: 'customSupportFormFields',
  PROSPECTS: 'prospects',
  MESSENGER_INTEGRATION: 'messengerIntegration',
  ADAPTIVE_TESTING: 'adaptiveTesting',
  FORM_FOLLOWUP_EMAILS: 'formFollowupEmails',
  MULTI_TOUCH_REVENUE_ATTRIBUTION: 'multiTouchRevenueAttribution',
  RECORD_CUSTOMIZATION: 'recordCustomization',
  CUSTOM_PROPERTIES: 'customProperties',
  BLOG: 'blog',
  DRAG_AND_DROP_EDITOR: 'dragAndDropEditor',
  CONTACT_ATTRIBUTION_REPORT_BUILDER: 'contactAttributionReportBuilder',
  WEBSITE_TRAFFIC_ANALYSIS: 'websiteTrafficAnalysis',
  SEO_RECOMMEND_OPTIMIZE: 'seoRecommendOptimize',
  BUILT_IN_AMP_SUPPORT: 'builtInAmpSupport',
  SMART_CONTENT_AND_REPORTING: 'smartContentAndReporting',
  WEBSITE_THEMES: 'websiteThemes',
  LOCAL_WEBSITE_DEVELOPMENT: 'localWebsiteDevelopment',
  ADVANCED_MENUS: 'advancedMenus',
  APP_AND_ASSET_MARKETPLACE: 'appAndAssetMarketplace',
  PASSWORD_PROTECTED_PAGES: 'passwordProtectedPages',
  MULTI_LANGUAGE_CREATION_TESTING: 'multiLanguageCreationTesting',
  CONTENT_STRATEGY: 'contentStrategy',
  CONTENT_STAGING: 'contentStaging',
  SUBDOMAIN_AND_COUNTRY_CODE_TLD: 'subdomainAndCountryCodeTLD',
  SITE_EXPORT: 'siteExport',
  BLOG_IMPORT: 'blogImport',
  URL_MAPPINGS: 'urlMappings',
  CDN: 'cdn',
  TWENTY_FOUR_SEVEN_SECURITY_MONITORING: '247securityMonitoring',
  MEMBERSHIPS: 'memberships',
  TWO_BRAND_DOMAINS: '2brandDomains',
  CODE_ALERTS: 'codeAlerts',
  REVERSE_PROXY_SUPPORT: 'reverseProxySupport',
  CUSTOM_CDN_CONFIGURATION: 'customCdnConfiguration',
  SITE_PERFORMANCE_MONITORING: 'sitePerformanceMonitoring',
  ACTIVITY_LOGGING: 'activityLogging',
  SERVERLESS_FUNCTIONS: 'serverlessFunctions',
  CONTENT_ANALYTICS_VIEW: 'contentAnalyticsView',
  TARGET_ACCOUNTS_HOME: 'targetAccountsHome',
  COMPANY_SCORING: 'companyScoring',
  ACCOUNT_OVERVIEW: 'accountOverview',
  FIELD_LEVEL_PERMISSIONS: 'fieldLevelPermissions'
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/self-service-api/static-1.1360/js/constants/Features.js
// module id = 156
// module chunks = 5 6 7